import Image from 'next/image';
import Link from 'next/link';
import { footerColumns } from '@/lib/marketing/navigation';
export function MarketingFooter() {
  return (
    <footer className="marketing-site border-t border-slate-200 bg-white text-[#0A1C33]">
      <div className="mx-auto max-w-[1240px] px-5 py-10 lg:px-8">
        <div className="mb-9 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
          <Link href="/" aria-label="Mentrox OneHR home">
            <Image
              src="/assets/images/app_logo.webp"
              alt="Mentrox OneHR"
              width={154}
              height={44}
              className="h-11 w-[154px] object-contain"
            />
          </Link>
          <p className="max-w-sm text-sm leading-6 text-slate-600">
            People. Process. Progress.
            <br />
            HR and workforce management by Mentrox Digital Solutions.
          </p>
        </div>
        <nav
          aria-label="Footer"
          className="grid grid-cols-2 gap-x-5 gap-y-8 md:grid-cols-3 lg:grid-cols-5"
        >
          {footerColumns.map((column) => (
            <div key={column.title}>
              <h2 className="text-xs font-bold uppercase tracking-wider text-slate-700">
                {column.title}
              </h2>
              <ul className="mt-4 space-y-2.5">
                {column.links.map(([label, href]) => (
                  <li key={href}>
                    <Link
                      href={href}
                      className="text-sm leading-6 text-slate-600 hover:text-orange-700"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
        <div className="mt-9 flex flex-col justify-between gap-4 border-t border-slate-200 pt-5 text-xs leading-6 text-slate-600 sm:flex-row">
          <span>© {new Date().getFullYear()} Mentrox OneHR. All rights reserved.</span>
          <nav aria-label="Legal" className="flex flex-wrap gap-x-5 gap-y-2">
            <Link href="/privacy">Privacy Policy</Link>
            <Link href="/terms">Terms of Service</Link>
            <Link href="/security">Security</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
